import { HOME_URL } from '~/constants/config';

export default (slug: string): string => {
  return slug.includes(HOME_URL) ? slug : `${HOME_URL}${slug}`;
};
